import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import APP_CONSTANTS from '@hkm/constants/app.constants';
import classNames from 'classnames';

import { TransactionCode2 } from '@ac/library-api';
import { AcBadge } from '@ac/mobile-components/dist/components/badge';
import {
  AcFieldNumber,
  AcFieldNumberVariant
} from '@ac/mobile-components/dist/components/field';
import { AcFlex } from '@ac/mobile-components/dist/components/flex';
import { AcText } from '@ac/mobile-components/dist/components/text';
import { AcTileShell } from '@ac/mobile-components/dist/components/tile';
import {
  AlignItems,
  Color,
  FlexDirection,
  JustifyContent,
  TextSize
} from '@ac/mobile-components/dist/enums';
import { Testable } from '@ac/mobile-components/dist/interfaces/componentProps';
import { FieldRenderProps } from '@ac/react-infrastructure';

import './TransactionCodeItem.css';

export interface TransactionCodeItemProps extends Testable {
  fieldProps: FieldRenderProps<number>;
  transactionCode: TransactionCode2;
  charged?: number;
}

const TransactionCodeItem: FC<TransactionCodeItemProps> = (
  props: TransactionCodeItemProps
) => {
  const {
    fieldProps: { input },
    transactionCode
  } = props;

  const { i18n, t } = useTranslation();
  const prefix = 'transaction-code-item';
  const shellClass = classNames(prefix, 'ac-spacing-top-sm', {
    selected: !!input.value
  });

  return (
    <AcTileShell className={shellClass} testSelector={props.testSelector}>
      <AcFlex alignItems={AlignItems.center}>
        <AcFlex
          direction={FlexDirection.column}
          justifyContent={JustifyContent.flexStart}
          className={`${prefix}-name`}
        >
          <AcText color={Color.Black} ellipsis={true}>
            {transactionCode.getSubCodeDescription(i18n.language) ||
              transactionCode.getSubCodeDescription(
                APP_CONSTANTS.FALLBACK_LANGUAGE
              )}
          </AcText>
          {!!props.charged && (
            <AcBadge
              fit={true}
              className="ac-spacing-top-s"
              borderColor={Color.Warning}
              badgeTextSize={TextSize.Main3}
              backgroundColor={Color.WarningLight}
              badgeText={t('POSTING.POSTING_DETAILS.CHARGED_ITEM', {
                count: props.charged
              })}
            />
          )}
        </AcFlex>

        <AcFlex
          justifyContent={JustifyContent.flexEnd}
          alignItems={AlignItems.center}
          className={`${prefix}-post`}
        >
          <AcFieldNumber
            {...input}
            min={0}
            max={APP_CONSTANTS.MAX_QUANTITY_SINGLE_CHARGE}
            variant={AcFieldNumberVariant.Borderless}
          />
        </AcFlex>
      </AcFlex>
    </AcTileShell>
  );
};

export default memo(TransactionCodeItem);



// WEBPACK FOOTER //
// ./src/components/Posting/PostingView/Body/TransactionCodeItem/TransactionCodeItem.tsx